import { Reducer, Action } from "redux";
import { IFamilyServiceState, IChildSubscriber, GET_FPS_FAMILY_MEMBER, FamilyServiceAction, GET_SFR_FAMILY_MEMBER, SFR_FAMILY_MEMBER_LOADER, GET_FAMILY_ADULT_MEMBER_DETAILS,LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS,RESET_FOR_FAMILY_ADULT_MEMBER_DETAILS } from "./types";

export const reducer: Reducer<IFamilyServiceState> = (state: IFamilyServiceState | undefined, incomingAction: Action): IFamilyServiceState => {
    if (state === undefined) {
        return {
            eZSChildSubscribers: [],
            seniorMemberList: [],
            isLoadingSFR: false,
            isAdultFamilyMember : false,
            isAdultFamilyMemberDetailsLoaded: false
        };
    }
    const action = incomingAction as FamilyServiceAction;
    switch (action.type) {
        case GET_FPS_FAMILY_MEMBER:
            return {
                ...state,
                eZSChildSubscribers: action.eZSChildSubscribers,
            };
        case GET_SFR_FAMILY_MEMBER:
            return {
                ...state,
                seniorMemberList: action.seniorMemberList,
            };
        case SFR_FAMILY_MEMBER_LOADER:
            return {
                ...state,
                isLoadingSFR: action.isLoadingSFR,
            };
        case GET_FAMILY_ADULT_MEMBER_DETAILS:
            return {
                ...state,
                isAdultFamilyMember: action.isAdultFamilyMember,
            };
        case LOADER_FOR_FAMILY_ADULT_MEMBER_DETAILS:
            return {
                ...state,
                isAdultFamilyMemberDetailsLoaded: action.isAdultFamilyMemberDetailsLoaded,
            };
        case RESET_FOR_FAMILY_ADULT_MEMBER_DETAILS:
            return {
                ...state,
                isAdultFamilyMemberDetailsLoaded: false,
                isAdultFamilyMember: false,
            };
        default:
            return state;
    }
};
